<template>
  <div class="wechat">
    <p class="wechat-info-important">{{$t('remark_wechat_config')}}</p>
    <div class="wechat-info-item">
      <p class="wechat-info-title">{{$t('wei_xin_pu_tong_shang_hu')}}</p>
      <el-form label-width="150px" class="wechat-info-form">
        <el-form-item :label="$t('zhi_fu_ming_cheng')">
          <el-input v-model="common.name" placeholder="请输入支付名称"></el-input>
        </el-form-item>
        <el-form-item :label="$t('gong_zhong_hao') + 'AppId:'">
          <el-input v-model="common.appId" :placeholder="$t('qing_shu_ru_gong_zhong_hao')+'AppId'"></el-input>
        </el-form-item>
        <el-form-item :label="$t('gong_zhong_hao') +'AppSecret:'">
          <el-input v-model="common.appSecret" :placeholder="$t('qing_shu_ru_gong_zhong_hao')+'AppSecret'"></el-input>
        </el-form-item>
        <el-form-item :label="$t('shang_hu_hao')">
          <el-input v-model="common.mchId" :placeholder="$t('qing_shu_ru_shang_hu_hao')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('shang_hu')+'AppSecret:'">
          <el-input v-model="common.mchSecret" :placeholder="$t('qing_shu_ru_shang_hu')+'AppSecret'"></el-input>
        </el-form-item>
        <el-form-item :label="$t('shou_quan_zheng_shu')">
          <el-input type="textarea" v-model="common.certPem"
                    :placeholder="$t('qing_dao_ru_shou_quan_zheng_shu')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('shou_quan_mi_yao')">
          <el-input type="textarea" v-model="common.certKey"
                    :placeholder="$t('qing_dao_ru_shou_quan_mi_yao')"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="wechat-btn">
      <el-button size="mini" @click="handleCreate">{{$t('bao_cun_she_zhi')}}</el-button>
    </div>
  </div>

</template>

<script>
  import {payWxCreate} from '@/api/delivery/pay/set'

  export default {
    name: '',
    components: {},
    props: {
      success: {
        type: Function,
        default: null
      }
    },
    mounted: function () {
    },
    data: function () {
      return {
        common: {
          name: '',
          appId: '',
          appSecret: '',
          mchId: '',
          mchSecret: '',
          certPem: '',
          certKey: '',
        },
        commonRule: [
          {name: 'name', error: this.$t('qing_shu_ru_zhi_fu_ming_cheng')},
          {name: 'appId', error: this.$t('qing_shu_ru_gong_zhong_hao') + 'AppId'},
          {name: 'appSecret', error: this.$t('qing_shu_ru_gong_zhong_hao') + 'AppSecret'},
          {name: 'mchId', error: this.$t('qing_shu_ru_shang_hu_hao')},
          {name: 'mchSecret', error: this.$t('qing_shu_ru_shang_hu') + 'AppSecret'},
        ],
        href: 'http://www.baidu.com'
      }
    },
    methods: {
      linkDownload() {
        // window.open(this.href, '_blank') // 新窗口打开外链接
      },
      handleCreate() {
        for (let i = 0; i < this.commonRule.length; i++) {
          let value = this.common[this.commonRule[i].name]
          if (!value) {
            this.$message.error(this.commonRule[i].error)
            return
          }
        }


        payWxCreate(this.common).then(res => {
          this.$message.success(this.$t('chuang_jian_cheng_gong'))
          if (this.success != null) {
            this.success({uuid: res, name: this.common.name, payStyle: 1})
          }
        })
      }
    },
  }
</script>

<style lang="scss">
  .wechat {
    padding: $padding;

    .wechat-info-important {
      font-size: .6rem;

      a {
        cursor: pointer;
        color: $btn_color;
      }

    }

    .wechat-info-item {
      .wechat-info-title {
        color: $f_sec_color;
        padding: $padding;
      }

      .wechat-info-form {
        padding: 0 $padding;

        .el-form-item__label {
          color: $f_th_color;
        }

        input {
          color: $f_th_color;
        }

        textarea {
          color: $f_th_color;
        }

        ::-webkit-input-placeholder {
          color: $f_sec_color;
        }

        :-moz-placeholder { /* Firefox 18- */
          color: $f_sec_color;
        }

        ::-moz-placeholder { /* Firefox 19+ */
          color: $f_sec_color;
        }

        :-ms-input-placeholder {
          color: $f_sec_color;
        }

        .el-textarea__inner {
          background-color: transparent;
        }

        .el-input__inner {
          border-color: $f_th_color;
        }
      }
    }

    .wechat-btn {
      text-align: center;

      .el-button {
        color: $f_color;
      }
    }
  }
</style>
